import { makeStyles } from '@material-ui/core/styles'
import ServiceSetImportTemplate from '../../../components/5templates/ServiceSetImportTemplate'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import SelectApproverModal from '../../../components/3modules/SmartForm/SelectApproverModal'
import { removeAllItemsInSessionStorage } from '../../../services/util/sessionStorageManager'
import FormSuccessSnackbar from '../../../components/2compounds/FormSuccessSnackbar'

const ImportNewServiceForm = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const [approver, setApprover] = useState(null)
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false)
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] = useState(false)
  const [showError, setShowError] = useState(false)

  const onPrev = () => {
    navigate('/adminDashboard')
  }

  const onNext = () => {
    setIsApproveModalOpen(true)
  }

  const onSubmit = () => {
    setShowError(true)
    if (approver) {
      setIsSuccessSnackbarOpen(true)
      window.setTimeout(() => {
        removeAllItemsInSessionStorage()
        navigate('/adminDashboard')
      }, 2000)
    }
  }

  return (
    <div className={classes.root}>
      <ServiceSetImportTemplate onPrev={onPrev} onNext={onNext} />
      <SelectApproverModal
        isModalOpen={isApproveModalOpen}
        setIsModalOpen={setIsApproveModalOpen}
        approver={approver}
        setApprover={setApprover}
        onSubmit={onSubmit}
        showError={showError}
      />
      <FormSuccessSnackbar
        isSnackbarOpen={isSuccessSnackbarOpen}
        setIsSnackbarOpen={setIsSuccessSnackbarOpen}
      />
    </div>
  )
}

export default ImportNewServiceForm

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '20px',
    marginLeft: '60px'
  }
})
